import React, { createContext, useReducer, useEffect, useContext} from 'react';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import { LanguageContext } from "../../containers/Language/LanguageProvider";
import { FETCH_OVERVIEW_REQUEST, SET_OVERVIEW_DATA, FETCH_OVERVIEW_SUCCESS,
        IS_OVERVIEW_FILTER_APPLIED, CLEAR_OVERVIEW_FILTER, SET_OVERVIEW_FILTER_DATA } 
        from '../actions/actionTypes';
import { fetchOverview, exportToExcelAuditDetails } from '../actions/actionSelectors';
import {CalendarContext} from './CalendarProvider';
import { auditReducer } from '../actions/audit-reducer';

const initialState = { 
    overview: [], 
    isBtnExportEnable: false,
    isOverviewFilterApplied: false,
    isClearOverviewFilter: false,
    overviewFilterData: [],
    overviewColumnFilterIndexes: []
}

export const AuditContext = createContext();

export function AuditProvider(props) {
    const languageContext = useContext(LanguageContext);
    const { fromRevenueDate, untilRevenueDate, errorOrWarningHandler, setIsLoading } = useContext(CalendarContext); 
    const [state, dispatch] = useReducer(auditReducer, initialState);
    const { overview, isBtnExportEnable, isOverviewFilterApplied, isClearOverviewFilter, 
        overviewFilterData, overviewColumnFilterIndexes } = state;

    useEffect(() => { if(props.isLogout) { props.clearSessionData(); }
    }, [ props.isLogout]);   

    useEffect(() => { fetchOverviewHandler(); }, []);

    const fetchOverviewHandler = async () => {
        setIsLoading(true); 
        dispatch({ type: FETCH_OVERVIEW_REQUEST });
            await fetchOverview()
                .then((data) => {
                    dispatch({
                        type: FETCH_OVERVIEW_SUCCESS,
                        payload: {
                            overview: data && typeof(data) !== 'string' ? data : []
                        }
                    });
                    setIsLoading(false); 
                })
                .catch((error) => {errorOrWarningHandler(true, "wentwrong", true, "audit"); })
    }  

    const handlerOnExportToExcelClick = async (exportSelectedAuditDetails) => {
        if(fromRevenueDate && untilRevenueDate && languageContext && languageContext.language 
        && exportSelectedAuditDetails) {
            setIsLoading(true);
            const selectedLangId = +languageContext.language.id;
            const auditDetailRequestModel = { 
                                                ...exportSelectedAuditDetails, 
                                                languageId: selectedLangId
                                            };
            await exportToExcelAuditDetails(auditDetailRequestModel)    
                .then((data)=>{
                    setIsLoading(false);
                    if(data) {
                        if(data.size) {
                            const tempDate = format(new Date(), "ddMMyyyy:HHmmss");
                            const fileName = (languageContext.labels["audit_file"]) + "_" + tempDate + ".xlsx";
                            saveAs(new Blob([data]), fileName);    
                        } else {
                            errorOrWarningHandler(true, "no_data_found", true, "audit");
                        } 
                    } else {
                        errorOrWarningHandler(true, "wentwrong", true, "audit");
                    }
                })
                .catch((error)=>{ errorOrWarningHandler(true, "wentwrong", true, "audit"); })     
        }
    } 
    
    const handlerOnOverviewDataSelection = (overviewDataOnSelection) => {
        dispatch({ type: SET_OVERVIEW_DATA, payload: { overview: overviewDataOnSelection } });
    }
    
    const handlerOnClearFilterClick = (isClear, isOverviewFilter) => {
        if(isOverviewFilter) {
            dispatch({ 
                type: CLEAR_OVERVIEW_FILTER,
                payload: {isClearOverviewFilter: isClear, overviewFilterData: []} 
            });
        }
    }

    const handlerCheckOverviewFilterApplied = (isAppliedFilter, filterData, columnIndexes) => {
        dispatch({ type: IS_OVERVIEW_FILTER_APPLIED,
                   payload: {isOverviewFilterApplied: isAppliedFilter, overviewFilterData: filterData, 
                             overviewColumnFilterIndexes: columnIndexes} 
                });
    }

    const handlerSetOverviewFilterData = (filterData, selctedFilterColumnIndexes) => {
        dispatch({ type: SET_OVERVIEW_FILTER_DATA, 
                   payload: {overviewFilterData: filterData, overviewColumnFilterIndexes: selctedFilterColumnIndexes} });
    }

    const provider = {
        overview,
        isBtnExportEnable,
        isOverviewFilterApplied,
        isClearOverviewFilter,
        overviewFilterData,
        overviewColumnFilterIndexes,
        handlerOnOverviewDataSelection,
        handlerOnExportToExcelClick,
        handlerOnClearFilterClick,
        handlerCheckOverviewFilterApplied,
        handlerSetOverviewFilterData     
    };

    return (
        <AuditContext.Provider value={provider}>
            {props.children}
        </AuditContext.Provider>
    );
}
